import React from "react";
import ReactEcharts from "echarts-for-react";

export const ChartsCounterParty = ({ data }) => {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const month = new Date();
  var count = 1;
  var legendMonth = [];
  legendMonth.push(month.getMonth());
  var m = new Date();
  if (data.count !== undefined || data.length !== 0) {
    data.series.map(() => {
      if (m.getMonth) {
        m.setMonth(m.getMonth() - 1);
        legendMonth.push(m.getMonth());
      }
      count = count + 1;
    });
  }

  let option = {
    title: {
      text: "Failing trades",
    },
    tooltip: {
      trigger: "axis",
      formatter: "",
    },
    legend: {
      data: data.name,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      //data: ["Oct", "Nov", "Dec", "Jan", "Feb"],
      data: [
        monthNames[legendMonth[4]],
        monthNames[legendMonth[3]],
        monthNames[legendMonth[2]],
        monthNames[legendMonth[1]],
        monthNames[legendMonth[0]],
      ],
    },
    yAxis: {
      type: "value",
    },
    series: data.series,
  };
  return <ReactEcharts option={option} />;
};
